/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimWidget } from './ClaimWidget';
import {
    ClaimWidgetFromJSON,
    ClaimWidgetFromJSONTyped,
    ClaimWidgetToJSON,
    ClaimWidgetToJSONTyped,
} from './ClaimWidget';

/**
 * 
 * @export
 * @interface ListClaimWidgets200Response
 */
export interface ListClaimWidgets200Response {
    /**
     * 
     * @type {Array<ClaimWidget>}
     * @memberof ListClaimWidgets200Response
     */
    widgets: Array<ClaimWidget>;
}

/**
 * Check if a given object implements the ListClaimWidgets200Response interface.
 */
export function instanceOfListClaimWidgets200Response(value: object): value is ListClaimWidgets200Response {
    if (!('widgets' in value) || value['widgets'] === undefined) return false;
    return true;
}

export function ListClaimWidgets200ResponseFromJSON(json: any): ListClaimWidgets200Response {
    return ListClaimWidgets200ResponseFromJSONTyped(json, false);
}

export function ListClaimWidgets200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListClaimWidgets200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'widgets': ((json['widgets'] as Array<any>).map(ClaimWidgetFromJSON)),
    };
}

export function ListClaimWidgets200ResponseToJSON(json: any): ListClaimWidgets200Response {
    return ListClaimWidgets200ResponseToJSONTyped(json, false);
}

export function ListClaimWidgets200ResponseToJSONTyped(value?: ListClaimWidgets200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'widgets': ((value['widgets'] as Array<any>).map(ClaimWidgetToJSON)),
    };
}

